














import { Vue, Prop, Component } from 'vue-property-decorator'

@Component
export default class Buttons extends Vue {
    // Prop => Datas envoyée depuis le composent parent à l'enfant (ici)
    @Prop() private btn1!: string
    @Prop() private btn2!: string
    @Prop() private btn3!: string
    @Prop() private btn4!: string
    @Prop() private step!: number

    // Data => (vide pour le moment car elle sera nourrie avec les props)
    private Btns: Array < unknown > = []

    private addPropInArray (): void {
      if (this.Btns.length > 0) {
        this.Btns.length = 0
      } else {
        this.Btns.push(this.btn1 as unknown, this.btn2 as unknown, this.btn3 as unknown, this.btn4 as unknown)
      }
    }

    // Ajoute un evenement "OnClick" sur les boutons pour lancer la sauvegarde
    private addEventInbtn () : void {
      const buttons = document.querySelectorAll('.btn-tunnel-item')
      if (buttons) {
        buttons.forEach((button) => {
          button.addEventListener('click', (event) => {
            if (event) {
              const btnCast = button as HTMLElement
              const buttonName = btnCast.dataset.name
              if (buttonName) {
                this.sendChoise(buttonName)
              }
            }
          }, false)
        })
      }
    }

    // Envoie la donnée à la méthode vuex correspondante à l'étape courante
    private sendChoise (name: string): void {
      if (name) {
        switch (this.step) {
          case 5 :
            this.$store.dispatch('saveStep5', name)
            // On envoie a la vue suivante
            this.$router.push({ name: 'Etape6' })
            break
          case 6 :
            this.$store.dispatch('saveStep6', name)
            // On envoie a la vue suivante
            this.$router.push({ name: 'EtapeForm' })
            break
            // Si il y a + d'étapes mettre la suite ici
          default:
            console.log('sortie de choise',name)
            break
        }
      }
    }

    private updateStyleBtn (btnSaved: string): void {
      if (btnSaved) {
        const btns = document.querySelectorAll('.btn-tunnel-item')
        btns.forEach((btn) => {
          const btnCast = btn as HTMLElement
          const btnName = btnCast.dataset.name as string
          if (btnSaved.localeCompare(btnName)) {
            if (btn.classList.contains('camif-btn')) {
              btn.classList.remove('camif-btn')
            }
            btn.classList.add('camif-btn-disable')
          } else {
            btn.classList.add('camif-btn')
            if (btn.classList.contains('camif-btn-disable')) {
              btn.classList.remove('camif-btn-disable')
            }
          }
        })
      }
    }

    private updateBTN (): void {
      let btnSaved = ''
      if (this.step) {
        switch (this.step) {
          case 5 :
            btnSaved = this.$store.getters.getValueForStep5
            this.updateStyleBtn(btnSaved)
            break
          case 6 :
            btnSaved = this.$store.getters.getValueForStep6
            this.updateStyleBtn(btnSaved)

            break
            // Si il y a + d'étapes mettre la suite ici
          default:
            break
        }
      }
    }

    created (): void {
      this.addPropInArray()
    }

    mounted (): void {
      this.addEventInbtn()
      this.updateBTN()
    }
}
